import { keyframes } from 'typestyle';

export const colors = {
  bodyBackground: '#f8f8f8',
  boxBackground: '#F0F2F2',
  danger: '#C8051E',
  darkBackgroundLink: '#CCCCCC',
  darkBackgroundLinkHover: '#FAFAFA',
  darkBlue: '#14385F',
  darkGray: '#343A40',
  error: '#dc3545',
  gray: '#ced4da',
  grey: '#ced4da',
  info: '#17a2b8',
  linkText: '#077398', // from bootstrap
  mediumGray: '#697576',
  navBarText: '#F7F7F9',
  primary: '#006baa',
  success: '#529329',
  textSecondary: '#575F67',
  warning: '#ffc107',
  white: '#ffffff',
};

export const darkBackgroundClasses = {
  link: {
    '&:hover': {
      color: colors.darkBackgroundLinkHover,
    },
    color: colors.darkBackgroundLink,
  },
};

export const barberpoleBackgroundAnimation = keyframes({
  '100%': {
    backgroundPosition: '100% 100%',
  },
});

export const barberpoleBackground = {
  animation: `${barberpoleBackgroundAnimation} 30s linear infinite`,
  backgroundImage: `
            repeating-linear-gradient(
                -45deg,
                transparent,
                transparent 1rem,
                #DDD 1rem,
                #DDD 2rem
            )
        `,
  backgroundSize: '400%',
};

export const sizesRem = {
  large: '1.5rem',
  medium: '1rem',
  small: '0.5rem',
  xlarge: '2rem',
  xsmall: '0.25rem',
  xxlarge: '4rem',
  xxsmall: '0.125rem',
};

export const sizes = {
  large: 24,
  largePx: '24px',
  medium: 16,
  mediumPx: '16px',
  small: 8,
  smallPx: '8px',
  xlarge: 32,
  xlargePx: '32px',
  xsmall: 4,
  xsmallPx: '4px',
  xxlarge: 64,
  xxlargePx: '64px',
  xxsmall: 2,
  xxsmallPx: '2px',
};

// Incomplete
export const imageSizes = {
  tableIcon: 38,
  tableIconPx: '38px',
};

export const styles = {
  shadow: '0 2px 4px 1px rgba(0, 0, 0, 0.10)',
};

export const composites = {
  cardShadow: {
    borderRadius: sizes.small,
    boxShadow: styles.shadow,
  },
};
